import api from '../../../../api/client'
import { invalidateEntity } from '../../../../api/cacheInvalidation'

export async function listMasterApprovals(params) {
  const { data } = await api.get('/masters/approvals/', { params })
  return data
}

export async function getMasterApprovalSummary(params) {
  const { data } = await api.get('/masters/approvals/summary', { params })
  return data
}

export async function getMasterApprovalDetail(requestId) {
  const { data } = await api.get(`/masters/approvals/${requestId}`)
  return data
}

export async function listSupportedModules() {
  const { data } = await api.get('/masters/approvals/modules')
  return data
}

export async function submitMasterChange(payload) {
  const { data } = await api.post('/masters/approvals/submit', payload)
  const mod = String(payload?.module_key || '').toLowerCase()
  if (mod === 'company') invalidateEntity.company()
  else if (mod === 'branch') invalidateEntity.branch()
  else if (mod === 'department') invalidateEntity.department()
  else if (mod === 'role') invalidateEntity.role()
  else if (mod === 'user') invalidateEntity.user()
  else invalidateEntity.approval()
  return data
}

export async function approveMasterRequest(requestId, reason) {
  const { data } = await api.patch(`/masters/approvals/${requestId}/approve`, { reason })
  invalidateEntity.approval()
  return data
}

export async function rejectMasterRequest(requestId, reason) {
  const { data } = await api.patch(`/masters/approvals/${requestId}/reject`, { reason })
  invalidateEntity.approval()
  return data
}

export async function bulkApproveMasterRequests(payload) {
  const { data } = await api.post('/masters/approvals/bulk-approve', payload)
  invalidateEntity.approval()
  return data
}

export async function bulkRejectMasterRequests(payload) {
  const { data } = await api.post('/masters/approvals/bulk-reject', payload)
  invalidateEntity.approval()
  return data
}
